var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { AlarmTypesClient, GetAlarmTypeListPaginatedQuery, PaginatedEnumerableOfAlarmTypeModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
const alarmTypesClient = new AlarmTypesClient(window.apiUrl);
let AlarmTypesVue = class AlarmTypesVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "AlarmTypeName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetAlarmTypeListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfAlarmTypeModel();
        this.columns = [
            { visible: true, fieldName: "alarmTypeName", title: "Name" },
            { visible: true, fieldName: "scopeName", title: "Scope" },
            { visible: true, fieldName: "measurementTypeName", title: "Measurament" },
            { visible: true, fieldName: "stringStatusName", title: "String Status" },
        ];
    }
    created() {
        this.loadDataGridState();
        this.search();
    }
    ;
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        alarmTypesClient
            .search(this.query)
            .then((response) => {
            this.data = new PaginatedEnumerableOfAlarmTypeModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("alarm-type-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    edit(alarmType) {
        this.$router.push({ name: RouteNames.AlarmType, params: { id: alarmType.alarmTypeId.toString() } });
    }
    ;
    archive(alarmType) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this alarm type?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            alarmTypesClient
                .delete(alarmType.alarmTypeId)
                .then(() => {
                alarmType.whenDeleted = new Date();
                Notifier.onOk(`Alarm Type # ${alarmType.alarmTypeId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(alarmType) {
        if (this.working)
            return;
        this.working = true;
        alarmTypesClient
            .restore(alarmType.alarmTypeId)
            .then(() => {
            alarmType.whenDeleted = undefined;
            Notifier.onOk(`Alarm Type # ${alarmType.alarmTypeId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("alarm-type-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
};
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmTypesVue.prototype, "search", null);
__decorate([
    Watch("query.includeDeleted"),
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmTypesVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmTypesVue.prototype, "onSortChanged", null);
AlarmTypesVue = __decorate([
    Component({
        name: "AlarmTypesVue"
    })
], AlarmTypesVue);
export default AlarmTypesVue;
